/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExamTestDateDto
 */
export interface ExamTestDateDto {
    /**
     * 
     * @type {Date}
     * @memberof ExamTestDateDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExamTestDateDto
     */
    startVersion?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExamTestDateDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExamTestDateDto
     */
    endVersion?: string | null;
}

/**
 * Check if a given object implements the ExamTestDateDto interface.
 */
export function instanceOfExamTestDateDto(value: object): value is ExamTestDateDto {
    return true;
}

export function ExamTestDateDtoFromJSON(json: any): ExamTestDateDto {
    return ExamTestDateDtoFromJSONTyped(json, false);
}

export function ExamTestDateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamTestDateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'startVersion': json['startVersion'] == null ? undefined : json['startVersion'],
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'endVersion': json['endVersion'] == null ? undefined : json['endVersion'],
    };
}

export function ExamTestDateDtoToJSON(value?: ExamTestDateDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'startDate': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString()),
        'startVersion': value['startVersion'],
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'endVersion': value['endVersion'],
    };
}

